<companyid-input
    i18n-placeholder="@@placeholder-your-work-email"
    placeholder="Your work email"
    type="input-border-left"
    [formControl]="emailFormControl"
    class="desk:w-250px tab:w-250px"
/>
<button i18n="@@button-get-started" class="button-primary rounded-r-14px rounded-l-none" (click)="sendEmail()">
    Get Started
</button>
